module.exports = __webpack_public_path__ + "static/media/S2C2.b5b7b59e.svg";